<template>
    <div class="activity">
        <!-- <AppNavbar :titleData="titleData" /> -->
        <AppNavbar :titleData="titleData" :focusItem="focusItem" @onFocus="onFocus" />
        <div class="myHeader" id="idMyHeader">
            <div class="titleBox">
                <p :style="{ color: '#FFFDFD', fontSize: '30px' }"></p>
                <p class="subTitle">了解最新的鲁商通新闻，获知最热的鲁商通动态</p>
            </div>
        </div>
        <div class="wrap" :style="{ minHeight: minHeight }">
            <div class="content">
                <ActivityContent :newsList="newsList" :zpList="zpList"></ActivityContent>
            </div>
        </div>
        <AppFooter class="footer" id="idFooter" />
    </div>
</template>
<script>
import AppNavbar from "@/components/AppNavbar";
import AppFooter from "@/components/AppFooter";
import ActivityContent from "@/components/ActivityContent";
export default {
    components: {
        AppNavbar,
        AppFooter,
        ActivityContent,
    },
    data() {
        return {
            titleData: [
                { url: "#", title: "首页" },
                { url: "#appActive", title: "近期动态" },
            ],
            newsList: [
                {
                    url: "https://mp.weixin.qq.com/s/dJv9MIE4LxPkRp0u_Ox_Xw",
                    title: `鲁商通荣获山东优质品牌服务认定`,
                    time: "2023-02-02",
                },
                {
                    url: "https://mp.weixin.qq.com/s/a0pP3ZBvgP1Aye6UNQeHjQ",
                    title: `鲁商通顺利通过高新技术企业认定备案公示`,
                    time: "2022-12-31",
                },
                {
                    url: "https://mp.weixin.qq.com/s/Ay6HJ2-P8cV2BGB4cDHVXg",
                    title: `放肆嗨，玩出彩，鲁商通4周年庆盛大开幕`,
                    time: "2022-10-2",
                },
                {
                    url: "https://mp.weixin.qq.com/s/dtHAQKLDLJ8ghua52wR3jg",
                    title: `山东省委书记李干杰这样推介“好客山东 好品山东”`,
                    time: "2022-9-10",
                },
                {
                    url: "https://mp.weixin.qq.com/s/8WSugHnLU4-boaRxSFGSiQ",
                    title: "“硬核”软实力！鲁商通被评为“双软企业”!",
                    time: "2022-7-5",
                },
                {
                    url: "https://mp.weixin.qq.com/s/eN0HBGNkKmIo0I3VyV9zOQ",
                    title: "鲁商通与山东财经大学共建商业大数据创新研究中心!",
                    time: "2022-7-5",
                },
                {
                    url: "https://mp.weixin.qq.com/s/G6c-2Fm5aix-5sNJZEdEjA",
                    title: "鲁商通实现山东省第一批技术创新项目立项新突破!",
                    time: "2022-6-14",
                }
                // { url: "https://mp.weixin.qq.com/s/qUVdY4HFm0UrprMyC9KWug", title: "鲁商通顺利通过信息安全管理体系资质认证", time: "2022-3-25" },
            ],
            zpList: [

            {
                    url: "https://mp.weixin.qq.com/s/KcynpSgKlYt4Hvo62F8MSA",
                    title: "抢先剧透！臻选年度品牌盛典",
                    time: "2022-12-27",
                },
                {
                    url: "https://mp.weixin.qq.com/s/6CxI5Ilj3RRQE4g_IVrXGQ",
                    title: "3天销售6万斤，鲁商通奏响消费助农新篇章",
                    time: "2022-12-16",
                },
                {
                    url: "https://mp.weixin.qq.com/s/WRf78j5XMapz4KNYXOab4g",
                    title: "共抗疫情丨用银豆+车油喜加油，全程“0接触”！",
                    time: "2022-12-09",
                },
                {
                    url: "https://mp.weixin.qq.com/s/lUbABnJTR5d9hS9lxUm-8A",
                    title: "“预防新冠，做自己健康第一责任人”倡议书",
                    time: "2022-12-08",
                },
                {
                    url: "https://mp.weixin.qq.com/s/6YmAgGlwmhntMzTi2PNDjA",
                    title: "鲁商30年丨千万红包已备好！速来参与活动领红包啦！",
                    time: "2022-11-26",
                },
                {
                    url: "https://mp.weixin.qq.com/s/WEgwdc3HHsgUjCPLkasv4A",
                    title: "各位会员！鲁商通银联云闪付满减券来咯！银豆兑换再升级！",
                    time: "2022-10-26",
                },
                {
                    url: "https://mp.weixin.qq.com/s/ssJvqrndEpj4jlO05odMbg",
                    title: "电商巨头「京东」商城强势入驻鲁商通！",
                    time: "2022-6-29",
                },
                {
                    url: "https://mp.weixin.qq.com/s/ZmO3lkFHeKmwr88ytAL9Ag",
                    title: "重磅！鲁商通银联立减礼完成技术升级！",
                    time: "2022-6-1",
                },
                {
                    url: "https://mp.weixin.qq.com/s/0LN77JRGncuY_yOHfhjbTA",
                    title: "银豆兑换丨饿了么会员+无套路10元美团外卖立减券，真香！",
                    time: "2022-5-20",
                },
                {
                    url: "https://mp.weixin.qq.com/s/-mc3TiUTRgKqNFu8-ebl0A",
                    title: "What？用银豆兑换立减礼缴水电煤费只花一分钱？",
                    time: "2022-3-16",
                },
                {
                    url: "https://mp.weixin.qq.com/s/4Bhqszdi0xhPpZTIa4D1qQ",
                    title: "这篇推送，我们准备了一年！",
                    time: "2021-12-31",
                },
            ],
            minHeight: "",
            focusItem: 1,
        };
    },
    computed: {},
    mounted() {
        this.getHeight();
    },
    methods: {
        getHeight() {
            let height = window.screen.height;
            let headerHeight =
                document.getElementById("idMyHeader").clientHeight;
            let footerHeight = document.getElementById("idFooter").clientHeight;
            this.minHeight = height - headerHeight - footerHeight + "px";
        },
        onFocus(index) {
            this.focusItem = index;
            this.$router.push({ name: "Home" });
        },
    },
};
</script>
<style scoped lang="scss">
::v-deep .subTitleRight {
    display: none !important;
}

.activity {
    .myHeader {
        background-image: url("../assets/images/activitybg.png");
        height: 287px;
        background-repeat: no-repeat;
        background-size: contain;
    }
}

.footer {
    // margin-top: -50px;
}

.wrap {
    width: 1200px;
    margin: 0 auto;
    background-color: #ffffff;
    margin-top: -50px;
    border-radius: 7px;
    padding: 50px 30px 50px 30px;
}

.titleBox {
    text-align: center;
    padding-top: 145px;
}

.subTitle {
    color: #999999;
    font-size: 14px;
}

.contentBox {
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;

    .content {
        padding: 40px 35px 50px 35px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 25px 2px rgba(40, 13, 13, 0.04);
        width: 570px;
    }
}

.vertical {
    width: 3px;
    height: 24px;
    background: #eb6100;
    border-radius: 1px 1px 1px 1px;
    display: inline-block;
    margin-right: 14px;
    margin-bottom: -4px;
}

.zpintro {
    margin-top: 10px;

    a {
        display: flex;
        justify-content: space-between;
        color: #000000;
        text-decoration: none;
    }
}

@media (max-width: 767.98px) {
    .myHeader {
        display: none;
    }

    .wrap {
        width: 100%;
        background: #f2f2f2;
    }
}
</style>
